import setPromiseState from '../../utils/promiseState';

export default{
  stateDropDown: false,
  onMainClick: false,
  tourCategories: [],
  cities: [],
  promise: {
    getCities: setPromiseState(),
    getTourCategories: setPromiseState(),
    contactUs: setPromiseState(),
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Main/InitState.js